import { GzComplexSearchWebComponent } from './component/GzComplexSearchWebComponent';
import { GzCustomInputSearchWebComponent } from './component/GzCustomInputSearchWebComponent';
import { WEB_COMPONENT_GZ_CUSTOM_INPUT_SEARCH } from '../../webcomponents.constants';

export { GzComplexSearchWebComponent, GzCustomInputSearchWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_CUSTOM_INPUT_SEARCH, GzCustomInputSearchWebComponent);
